import { render } from "./HomePageAttivita.vue?vue&type=template&id=351953ce"
import script from "./HomePageAttivita.vue?vue&type=script&lang=js"
export * from "./HomePageAttivita.vue?vue&type=script&lang=js"

import exportComponent from "D:\\documenti\\Lavoro\\Niemit\\com.niemit.cortebenedetto\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__